import * as React from "react";
import PageContainer from "../core/PageContainer";
import Card from "../core/Card";
import { HashRouter, Route, Link } from "react-router-dom";
const chartecImage = "https://chartec-core-public.s3-us-west-1.amazonaws.com/chartec-main-room.png";
const arrcImage = "https://chartec-core-public.s3-us-west-1.amazonaws.com/arrc-training-room.png";
import StreamPlayer from "../streaming/StreamPlayer";
import Breadcrumbs from "../core/Breadcrumbs";

interface IProps {}

interface IState {}

class Streams extends React.Component<IProps, IState> {
  render() {
    return (
      <PageContainer>
        <Breadcrumbs crumbs={[{ label: "CharTec Livestreams" }]} />
        <HashRouter hashType={"noslash"}>
          <>
            <Route
              path={"/"}
              exact
              render={() => (
                <Card>
                  <div className="columns">
                    <div className="column">
                      <StreamListing
                        name={"chartec"}
                        image={chartecImage}
                        label={"CharTec Main Room"}
                      />
                    </div>
                    <div className="column">
                      <StreamListing
                        name={"arrc"}
                        image={arrcImage}
                        label={"ARRC Training Room"}
                      />
                    </div>
                  </div>
                </Card>
              )}
            />
            <Route path={"/:streamName"} component={StreamPlayer} />
          </>
        </HashRouter>
      </PageContainer>
    );
  }
}

export default Streams;

function StreamListing({ name, label, image }) {
  return (
    <Link to={name}>
      <div className="columns is-centered">
        <div className="column is-8">
          <img src={image} alt="" style={{ width: "100%" }} />
        </div>
      </div>
      <p>&nbsp;</p>
      <button
        className="btn btn-info"
        style={{ width: "100%", height: "50px", fontSize: "14pt" }}
      >
        {label}
      </button>
    </Link>
  );
}



// WEBPACK FOOTER //
// ./app/javascript/components/pages/Streams.tsx